document.addEventListener("DOMContentLoaded", (event) => {
  const navigationBar = document.querySelector('#navigation-bar');
  const customNavigationOverlay = document.querySelector('#custom-navigation-overlay');
  const customNavigation = document.querySelector('#custom-navigation');
  const closeBtns = customNavigation.querySelectorAll('svg.icon-close');
  const backBtns = customNavigation.querySelectorAll('span.back-btn');
  const allLinksWithChild = customNavigation.querySelectorAll('a[data-has-child]');
  
  navigationBar.addEventListener('click', () => {
    customNavigation.classList.add('active');
    customNavigation.setAttribute('aria-expanded', true);
  });

  const closeNavigation = () => {
    customNavigation.classList.remove('active');
    customNavigation.setAttribute('aria-expanded', false);
  }
  
  customNavigationOverlay.addEventListener('click', closeNavigation);
  
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeNavigation);
  })

  backBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const subContent = btn.closest('.navigation-subcontent');
      subContent.classList.remove('active');
    });
  });

  allLinksWithChild.forEach(link => {
    link.onclick = (e) => {
      e.preventDefault();
      const subContent = link.parentElement.querySelector(':scope > .navigation-subcontent');

      if (!subContent.classList.contains('active'))
        subContent.classList.add('active');
    };
  });

  new Swiper('#custom-navigation .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const crossKissenButton = document.getElementById("cross-kissen");

  if (crossKissenButton) {
    const status = crossKissenButton.getAttribute("data-status");
    const showedKissen = sessionStorage.getItem("showedKissen");

    // Prüfen, ob `data-status` "true" ist und ob `showedKissen` auf "false" steht oder nicht gesetzt ist
    if (status === "true" && (showedKissen !== "true")) {
      // Automatischer Klick auf den Button
      crossKissenButton.click();
      sessionStorage.setItem("showedKissen", "true");

    }
  }
});

// Alma App: (0,99% Finanzierung) hinzufügen
document.addEventListener('DOMContentLoaded', () => {

  const addText = () => {
    const infoEl = document.querySelector('.alma-payment-plans-payment-info');

    if (!infoEl.querySelector('.custom-financing-info')) {
      const span = document.createElement('span');
      span.className = 'custom-financing-info';
      span.textContent = ' (0,99% Finanzierung)';
      infoEl.appendChild(span);
    }
  }

  const almaCheckTimer = setInterval(() => {
    const infoEl = document.querySelector('.alma-payment-plans-payment-info');

    if (infoEl) {
      addText();

      clearInterval(almaCheckTimer);
    }
  }, 500);

  
});